import state from "./moduleMonitoringVesselManeuveringState.js";
import mutations from "./moduleMonitoringVesselManeuveringMutations.js";
import actions from "./moduleMonitoringVesselManeuveringActions.js";
import getters from "./moduleMonitoringVesselManeuveringGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
